import { render, staticRenderFns } from "./FormControlModulestructureSelectType.vue?vue&type=template&id=9732f846&scoped=true"
import script from "./FormControlModulestructureSelectType.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureSelectType.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulestructureSelectType.vue?vue&type=style&index=0&id=9732f846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9732f846",
  null
  
)

export default component.exports